






























import { SearchDistributionData } from '@empathybroker/tsclient-stats/dist/models/distributionreport/searchdistributiondata';

import { ResizeObserver as ResizeObserverPolyfill } from '@juggle/resize-observer';

import { mapGetters } from 'vuex';

import { KpiEnum } from '../../enums';

import { capitalizeSentence } from '../../filters';

import { Dictionary, PeriodsData } from '../../models';

import { ANALYTICS_CONSTS } from '../../store/analytics/analytics.consts';

import { CONFIG_CONSTS } from '../../store/config/config.consts';

import { UiTooltip } from '../keen-ui';

export enum AnimationStepsIndexEnum {
  INITIAL_DELAY = 0,
  KPIS = 1
}

export default {
  name: 'stepped-kpis-bar',
  components: {
    UiTooltip
  },
  props: {
    selectedId: String,
    animationStepDurationsInMillis: Array,
    currentAnimationStep: Number
  },
  computed: {
    ...mapGetters(CONFIG_CONSTS.moduleName, {
      kpis: CONFIG_CONSTS.getters.kpis
    }),
    ...mapGetters(ANALYTICS_CONSTS.moduleName, {
      data: ANALYTICS_CONSTS.getters.data
    }),
    steppedKpisBarData: function (): Dictionary<number> {
      let distData: PeriodsData;
      if (!this.selectedId) {
        distData = this.data.overall.dist;
      } else {
        const selectedIdData = this.data.ids[this.selectedId];
        if (!!selectedIdData) {
          distData = selectedIdData.dist;
        }
      }
      const availableKpisInTemplate = [].concat(...this.kpisTemplateGroups);
      const data = availableKpisInTemplate.reduce((processedData, kpi: KpiEnum) => {
        processedData[kpi] = 0;
        return processedData;
      }, {});

      if (!!distData && !!distData.currentPeriod) {
        availableKpisInTemplate.forEach((kpi: KpiEnum) => data[kpi] = this.getKpiData(kpi, distData.currentPeriod.data));
      }
      return data;
    },
    kpisTemplateGroups: function () {
      const initialTemplateKpisGroups = [
        [KpiEnum.NO_RESULTS],
        [this.noClicks],
        [
          KpiEnum.CLICKS,
          KpiEnum.FINDABILITY
        ],
        [KpiEnum.ADD2CART],
        [KpiEnum.CHECKOUT]
      ];

      return initialTemplateKpisGroups.reduce((kpisTemplateGroups: any[], groupedKpis: string[]) => {
        const availableKpisInGroup: string[] = groupedKpis.filter(
          kpi => (!(Object.values(KpiEnum) as string[]).includes(kpi)) || (this.kpis.includes(kpi)));
        if (!!availableKpisInGroup.length) {
          kpisTemplateGroups.push(availableKpisInGroup);
        }
        return kpisTemplateGroups;
      }, []);
    },
    kpisDisplayGroups: function () {
      return [
        [KpiEnum.NO_RESULTS, this.noClicks, KpiEnum.CLICKS],
        [KpiEnum.FINDABILITY],
        [KpiEnum.ADD2CART],
        [KpiEnum.CHECKOUT]
      ];
    },
    kpiTransitionDurationInMillis: function (): number {
      return (this.animationStepDurationsInMillis[AnimationStepsIndexEnum.KPIS] / this.kpisDisplayGroups.length);
    },
    kpisGroupsTotalPercentage: function (): number {
      return this.kpisTemplateGroups.reduce((totalPercentage: number, kpisGroup: string[]) => {
        totalPercentage += this.getKpisGroupMaxPercentage(kpisGroup);
        return totalPercentage;
      }, 0);
    }
  },
  data: function () {
    return {
      noClicks: 'no-clicks',
      lastKpisIndexDisplayed: undefined,
      resizeObserver: undefined,
      messages: this.$epb.messages.analytics,
      AnimationStepsIndexEnum
    };
  },
  methods: {
    getKpiData: function (kpi: string, dataset: SearchDistributionData): number {
      return {
        [KpiEnum.CLICKS]: () => dataset.clickCountPct,
        [this.noClicks]: () => 100 - (dataset.clickCountPct + dataset.noResultsCountPct),
        [KpiEnum.FINDABILITY]: () => dataset.findability,
        [KpiEnum.ADD2CART]: () => dataset.add2cartCountPct,
        [KpiEnum.CHECKOUT]: () => dataset.checkoutCountPct,
        [KpiEnum.NO_RESULTS]: () => dataset.noResultsCountPct
      }[kpi]();
    },
    getKpiLabel: function (kpi: string): string {
      const kpisMessages = this.messages.kpis;
      const kpiMessage = {
        [KpiEnum.CLICKS]: () => kpisMessages[KpiEnum.CLICKS].percentageLabel,
        [this.noClicks]: () => this.messages.noClicks,
        [KpiEnum.FINDABILITY]: () => kpisMessages[KpiEnum.FINDABILITY].percentageLabel,
        [KpiEnum.ADD2CART]: () => kpisMessages[KpiEnum.ADD2CART].percentageLabel,
        [KpiEnum.CHECKOUT]: () => kpisMessages[KpiEnum.CHECKOUT].percentageLabel,
        [KpiEnum.NO_RESULTS]: () => kpisMessages.noResults.valueLabel
      }[kpi]();

      return capitalizeSentence(kpiMessage);
    },
    getKpisGroupMaxPercentage: function (kpisGroup: string[]): number {
      return Math.max(...kpisGroup.map(kpi => this.steppedKpisBarData[kpi]));
    },
    getKpisDisplayGroupIndex: function (kpi: string): number {
      return this.kpisDisplayGroups.findIndex((kpisDisplayGroup) => kpisDisplayGroup.includes(kpi));
    },
    getKpiTooltipText: function (kpi: string): string {
      return `${ this.getKpiLabel(kpi) }: ${ this.$epb.utils.formatNumber(this.steppedKpisBarData[kpi]) }%`;
    },
    isKpiDisplayed: function (kpi: string): boolean {
      return (this.getKpisDisplayGroupIndex(kpi) <= this.lastKpisIndexDisplayed);
    }
  },
  mounted: function (): void {
    const ResizeObserver = (window['ResizeObserver'] || ResizeObserverPolyfill);
    this.resizeObserver = new ResizeObserver((entries) => {
      entries.forEach((entry) => {
        const { width } = entry.contentRect;
        const entryTitles: Element[] = Array.from(entry.target.getElementsByClassName('epb-stepped-kpis-bar__text--kpi-label'));
        entryTitles.forEach(
          (title: HTMLElement) => title.style.visibility = (title.getBoundingClientRect().width > width) ? 'hidden' : 'visible');
      });
    });
    this.$refs.kpisGroup.forEach(kpisGroup => this.resizeObserver.observe(kpisGroup));
  },
  beforeDestroy: function (): void {
    this.resizeObserver.disconnect();
  },
  watch: {
    currentAnimationStep: function (): void {
      if (this.currentAnimationStep === AnimationStepsIndexEnum.KPIS) {
        this.lastKpisIndexDisplayed = 0;
      }
    }
  }
};
